import { render, staticRenderFns } from "./CuentaCobrarPage.vue?vue&type=template&id=ff5ad8ac"
import script from "./CuentaCobrarPage.js?vue&type=script&lang=js&external"
export * from "./CuentaCobrarPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports